<template>
  <div class="customer-board-wrap">
    <card-template
      :bg="platformCumston"
      title="平台客户对接上线数（近12月）"
      tips="对接上线口径：客户所调用对接方案，首次达到方案内接口连续7天调用大于10次。"
      style="margin-top: 80px;"
    >
      <docking-reports id="plat-demand-board"/>
    </card-template>

    <card-template
    :bg="rectification"
    title="对接方案文档差评整改情况公示（近3月）"
    tips="差评口径：客户对方案所属文档评价“无帮助”，并输入差评原因，每一条数据对应一个差评；<br/>
          已整改口径：方案负责人根据差评完善文档，并在<a href='//ops-lcp.jdl.com/#/operationReport/document-evaluation-details' target='_blank'>开放平台运维端</a>处理差评状态。<br/>
          运维端权限开通联系xnwlgateway。">
      <rectification-boards />
    </card-template>

    <card-template
      :bg="customization"
      title="定制化客户接入情况（近3月）"
      tips="定制化客户：通用API已经不能满足需求，需要对接定制化API的客户，多见于业务量较大的客户。"
    >
      <customized />
    </card-template>

    <div class="small-cards">
      <card-template
        :bg="evaluate"
        title="客户对接后评价（近6月）"
        tips="数据来源：客户在开放平台完成对接后，对方案的文档描述、平台功能、客服答疑进行的评价。"
        class="samll-card-item custom-evaluate-margin"
      >
        <custom-evaluate/>
      </card-template>
      <card-template
        :bg="nephogram"
        title="客户提问高频关键词云图（近6月）"
        tips="高频关键词：客户在工单提问过程中出现次数最多的前50个关键词，并由大到小展示"
        class="samll-card-item"
      >
        <cloud-words id="clond-words-charts"/>
      </card-template>
    </div>

    <div class="small-cards" style="margin-bottom: 16px;">
      <card-template
        :bg="it"
        title="IT工单响应时效（近6月）"
        tips="承诺响应时效：IT承诺工作日4小时内响应客户。图中数据包含了非工作日时效，因此可能偏高。"
        class="samll-card-item"
      >
        <IT-board id="it-charts"/>
      </card-template>
      <card-template
        :bg="experienceImage"
        title="客户对接体验评分（近6月）"
        tips="评分口径：客户在开放平台完成对接后，对文档描述、平台功能、客服答疑的评价平均分。"
        class="samll-card-item"
      >
        <experience id="experience-charts"/>
      </card-template>
    </div>

  </div>
</template>

<script>
import dockingReports from './components/dockingReports.vue'
import cardTemplate from './components/cardTemplate.vue'
import cloudWords from './components/cloudWords.vue'
import RectificationBoards from './components/RectificationBoards/index.vue'
import customized from './components/customized/index.vue'
import customEvaluate from './components/customEvaluate/index.vue'
import ITBoard from './components/ITBoard.vue'
import experience from './components/experience.vue'

import platformCumston from '@/assets/front/platformCumston.png'
import nephogram from '@/assets/front/nephogram.png'
import rectification from '@/assets/front/Rectification.png'
import customization from '@/assets/front/customization.png'
import evaluate from '@/assets/front/evaluate.png'
import it from '@/assets/front/IT.png'
import experienceImage from '@/assets/front/experience.png'

export default {
  components: {
    dockingReports,
    cardTemplate,
    cloudWords,
    RectificationBoards,
    customized,
    customEvaluate,
    ITBoard,
    experience
  },
  data() {
    return {
      platformCumston,
      nephogram,
      rectification,
      customization,
      evaluate,
      it,
      experienceImage,
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-board-wrap {
  display: grid;
  justify-content: center;
  align-items: center;
}
.tips {
  width: 320px;
  height: 164px;
  .title {

  }
  .contents {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    .items {

    }
  }
}
.small-cards {
  display: grid;
  justify-content: center;
  align-items: center;
  margin-left: -16px;
  grid-template-columns: repeat(2,1fr);
  .samll-card-item {
    margin-left: 16px;
  }
}

.custom-evaluate-margin {
  /deep/.customer-card {
    margin-right: 6px !important;
  }
}
</style>
